<template>

  <div id="activitas_creator" class="bg-white">
    <div class="activitas_creator__page-grid printable-area no-outline p6">

      <div v-for="i in Math.ceil(this.uebung.content_data.length / 4)">
        <div class="activitas_creator__page-row">
          <div class="activitas_creator__word-container"
            v-for="(word, key, index) in this.uebung.content_data.slice((i - 1) * 4, i * 4)">
            <div class="w100 flex-group-end">
              <button class="activitas_creator_remove-button" @click="remove(word)"><i class="hi hi-trash"></i></button>

            </div>
            <uebung-activitas-single-card-activity-switcher></uebung-activitas-single-card-activity-switcher>
            <div class="activitas_creator__word-container__word font-bold mt-2" v-html="word.lemma" ></div>

          </div>
        </div>
      </div>
    </div>
    <div class="activitas_creator__page-credits text-base ml-5">erstellt auf www.hermeneus.eu</div>

  </div>
</template>

<script>
import UebungActivitasSingleCardActivitySwitcher from "./UebungActivitasSingleCardActivitySwitcher.vue";

export default {
  name: "uebung-activitas-print-component",
  components: {
    'uebung-activitas-single-card-activity-switcher': UebungActivitasSingleCardActivitySwitcher
  },
  props: {
    data: {
      type: Object,
      required: true,
      default: () => {
        return {
          uebung: {},
          metadata: {}
        }
      }
    }
  },
  data() {
    return {
      uebung: this.data.uebung.printData,
      metadata: this.data.metadata
    }
  },
  computed: {
    vocab_filtered: function () {
      return this.uebung.content_data;
    }
  },
  methods: {
    isDivisable(key) {
      let index = key + 1;
      if (index % 20 === 0) {
        return true;
      }
    },
    remove(vocab_index) {
      this.uebung.content_data = this.uebung.content_data.filter((Value, Index) => {
        return Index !== vocab_index;
      });
    },
    remove(remove_word) {
      this.uebung.content_data = this.uebung.content_data.filter((word, Index) => {
        return word !== remove_word;
      });
    },
    print() {
      window.print();
    }
  },
}
</script>

<style scoped>
#activitas_creator {
  font-size: 16pt;
  font-family: "Merriweather", serif;
}

#activitas_creator button {
  background: #ddd;
  padding: 5px;
}

#activitas_creator button:hover i {
  color: #B22E2F;
}

.activitas_creator__page-grid {
  width: 19cm;
}

.activitas_creator__page-grid .activitas_creator__page-row {
  width: 19cm;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
}

.activitas_creator__page-grid .activitas_creator__word-container {
  text-align: center;
  width: 25%;
  height: 4.5cm;
  border: 1px dashed #aaa;
}

.activitas_creator__word-container__word {}


.activitas-activity__symbol {
  font-size: 24pt;
}


.activitas_creator__page-credits {}

@media print {
  .activitas_creator__page-grid {
    padding: 0
  }

  .activitas-activity__switcher {
    display: none;
  }

  .activitas_creator_remove-button {
    display: none;
  }

  .activitas__creator__description {
    display: none;
  }

  .activitas_creator__word-container {
    padding-top: 2rem;
  }

  .activitas_creator__page-row {
    break-inside: avoid;
  }

}
</style>